import { useEffect } from "react";
import { Capacitor } from "@capacitor/core";

// Android hardware back button: without this, Android's default behavior
// can exit the app instead of navigating back within the SPA. No-ops
// entirely on web/PWA and on iOS (there is no backButton event to fire).
export const NativeBackButton = () => {
  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    let removeListener: (() => void) | undefined;
    let cancelled = false;

    import("@capacitor/app").then(({ App }) => {
      if (cancelled) return;
      App.addListener("backButton", ({ canGoBack }) => {
        if (canGoBack) {
          window.history.back();
        } else {
          App.exitApp();
        }
      }).then((handle) => {
        if (cancelled) handle.remove();
        else removeListener = () => handle.remove();
      });
    }).catch(() => {});

    return () => {
      cancelled = true;
      removeListener?.();
    };
  }, []);

  return null;
};
